import { Component,OnInit, AfterViewInit, ViewChild } from '@angular/core';

import { HttpClient, HttpClientModule,HttpParams } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { formatDateMMDDYYYY, getWithApiKey } from '../utility/data-utils'; 

import { ActivatedRoute,Router, RouterLink } from '@angular/router'; 

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatTableModule } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { ApiService } from '../utility/api.service';

import { environment } from '../environments/environment';

@Component({
  selector: 'app-config-home',
  imports: [CommonModule,HttpClientModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatProgressSpinnerModule,
    RouterLink
  ],
  templateUrl: './config-home.component.html',
  styleUrl: './config-home.component.css'
}) 

export class ConfigHomeComponent implements OnInit , AfterViewInit {
  files: any;

  displayedColumns: string[] = [
    'filename','filesize','modified_date','view','download'
  ];

  dataSource = new MatTableDataSource<any>([]);

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  error: string | null = null;


  showTable = true;
  showProgress = false;

  constructor(private api: ApiService,
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient

  ) {}

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  ngOnInit() {

    this.showProgress = true;

    const currentPath = this.router.url;

    let endpoint = 'publish';
    if (currentPath.includes('/manual')) {
      endpoint = 'manual';
    }

    this.api.get(endpoint) 
      .subscribe({
        next: (data) => {
          console.log(data);
          this.files = data;
          this.dataSource.data = data;
          this.showProgress = false;
        },
        error: (err) => {
          this.error = err.message;
          if (err.message === 'Request timed out!') {
            alert('The request timed out. Please try again.');
          } else {
            console.error('Error fetching dashboard data:', err);
          } 
        }
      });
  }

  // Download file
  downloadFile(data: any): void {

    this.api.downloadFile(data.folder_name, data.file_name_with_ext).subscribe({
    next: (blob: Blob) => {
      // 1. Create a local URL for the downloaded blob data in memory
      const blobUrl = window.URL.createObjectURL(blob);

      // 2. Create an anchor tag and simulate a click
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = data.file_name_with_ext;

      document.body.appendChild(link);
      link.click();

      // 3. Clean up the DOM and release memory
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    },
    error: (error) => {
      console.error('File download failed:', error);
      }
    }
  );
}
  // Apply readable file sizes
  formatBytes(bytes: number, decimals: number = 2): string {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }
}
